import React from 'react';

import { IconProps } from 'icons/Icon.types';

export function Launch({ size, color }: IconProps) {
  return (
    <svg
      width={size ?? 24}
      height={size ?? 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Launch</title>
      <path
        d="M11 5.75C11.4142 5.75 11.75 5.41421 11.75 5C11.75 4.58579 11.4142 4.25 11 4.25V5.75ZM19.75 12.25C19.75 11.8358 19.4142 11.5 19 11.5C18.5858 11.5 18.25 11.8358 18.25 12.25H19.75ZM19 5H19.75C19.75 4.58579 19.4142 4.25 19 4.25V5ZM15 4.25C14.5858 4.25 14.25 4.58579 14.25 5C14.25 5.41421 14.5858 5.75 15 5.75V4.25ZM18.25 9C18.25 9.41421 18.5858 9.75 19 9.75C19.4142 9.75 19.75 9.41421 19.75 9H18.25ZM8.46967 14.4697C8.17678 14.7626 8.17678 15.2374 8.46967 15.5303C8.76256 15.8232 9.23744 15.8232 9.53033 15.5303L8.46967 14.4697ZM17 18.25H7V19.75H17V18.25ZM5.75 17V7H4.25V17H5.75ZM7 5.75H11V4.25H7V5.75ZM18.25 12.25V17H19.75V12.25H18.25ZM7 18.25C6.30964 18.25 5.75 17.6904 5.75 17H4.25C4.25 18.5188 5.48122 19.75 7 19.75V18.25ZM17 19.75C18.5188 19.75 19.75 18.5188 19.75 17H18.25C18.25 17.6904 17.6904 18.25 17 18.25V19.75ZM5.75 7C5.75 6.30964 6.30964 5.75 7 5.75V4.25C5.48122 4.25 4.25 5.48122 4.25 7H5.75ZM19 4.25H15V5.75H19V4.25ZM18.25 5V9H19.75V5H18.25ZM9.53033 15.5303L19.5303 5.53033L18.4697 4.46967L8.46967 14.4697L9.53033 15.5303Z"
        fill={color ?? 'currentColor'}
      />
    </svg>
  );
}
